import client from 'utils/api/client'

const api = {
  getPublicFeatureFlags: () => {
    return client.get('/public_feature_flags')
  },
}

export default api
